import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentSikring } from "@/components/DocumentSikring/DocumentSikring";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/")({
  loader: async ({ params }) => {
    const { tluxCaseId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sikring.defaults.$get({
      param: {
        tluxCaseId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch sikring template");
    }

    return {
      sikring: await res.json(),
    };
  },
  head: () => {
    return {
      meta: [{ title: "Opprett sikring | Alice & Bob" }],
    };
  },
  component: Page,
});

function Page() {
  const { tluxCaseId } = Route.useParams();
  const { sikring } = Route.useLoaderData();

  return (
    <CustomerLayout>
      <DocumentSikring tluxCaseId={tluxCaseId} sikring={sikring} cancelUrl={`/oppdrag/${tluxCaseId}`} />
    </CustomerLayout>
  );
}
